<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<!--<div class="container" [matTooltip]="statName" #tooltip="matTooltip">
  <img class="modIcon" [class.minor]="true" [src]="ModUrl[1+3*stat]">
  <span class="modText" [class.minor]="true">×{{amountMinor}}</span>
</div>
-->

<div class="row-mod">
  <div
    class="container tuning-mod"
    *ngFor="let tuningMod of getTuningModCounts(); trackBy: trackTuningModByHash"
    [matTooltip]="getTuningModName(tuningMod.hash)">
    <app-item-icon [itemHash]="tuningMod.hash"></app-item-icon>
    <span class="modText" *ngIf="tuningMod.count > 1">×{{ tuningMod.count }}</span>
  </div>

  <ng-container *ngVar="artifice | count as artificeCount">
    <div class="container" *ngIf="artificeCount > 0" matTooltip="Artifice" #tooltip="matTooltip">
      <img class="artificeIcon artifice" [src]="artificeUrl" />
      <span class="modText artifice">×{{ artificeCount }}</span>
    </div>
  </ng-container>

  <ng-container *ngFor="let stat of modIndex">
    <ng-container *ngFor="let modType of modTypeIndex">
      <ng-container *ngVar="mods | count: getModifier(stat, modType) as count">
        <div
          class="container"
          *ngIf="count > 0"
          [matTooltip]="getStatName(stat)"
          #tooltip="matTooltip">
          <img
            class="modIcon modIcon_{{ getStatName(stat) }}"
            [class.minor]="modType === 1"
            [src]="ModUrl[getModifier(stat, modType)]" />
          <span class="modText" [class.minor]="modType === 1">×{{ count }}</span>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
